import React from 'react';
import { useDispatch } from 'react-redux';
import {logout} from "../../../features/userSlice"
import { useNavigate } from 'react-router-dom';

const Menu = ({setShowCreateGroup}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return (
        <div className='absolute end-1 top-full mt-1 z-50 dark:bg-dark_bg_2 dark:text-dark_text_1 shadow-md w-52 rounded-lg overflow-hidden'>
            <ul>
                <li className='py-3 ps-5 cursor-pointer hover:bg-dark_bg_3' onClick={() => navigate('/app/dashboard')}>
                    <span>لوحة التحكم</span>
                </li>
                <li className='py-3 ps-5 cursor-pointer hover:bg-dark_bg_3' onClick={() => navigate('/app/inbox')}>
                    <span>صندوق الوارد</span>
                </li>
                <li className='py-3 ps-5 cursor-pointer hover:bg-dark_bg_3' onClick={() => navigate('/app/users')}>
                    <span>المستخدمون</span>
                </li>
                <li className='py-3 ps-5 cursor-pointer hover:bg-dark_bg_3' onClick={() => navigate('/app/platform-pages')}>
                    <span>صفحات المنصات</span>
                </li>
                <li className='py-3 ps-5 cursor-pointer hover:bg-dark_bg_3' onClick={() => navigate('/app/settings')}>
                    <span>الإعدادات</span>
                </li>
                <li className='py-3 ps-5 cursor-pointer hover:bg-dark_bg_3' onClick={()=>{
                    localStorage.removeItem('adminToken');
                    dispatch(logout());
                    navigate('/login');
                }}>
                    <span>تسجيل الخروج</span>
                </li>
            </ul>

        </div>
    );
}

export default Menu;
